import React from 'react';
import Layout from '../../components/Layout';
import SubNavBar from '../../components/SubNavBar/SubNavBar';
import DataRights from './DataRights';
import DeleteAccountPublic from '../deleteAccount/DeleteAccountPublic';

// CCPA/CPRA — authenticated client Data Rights self-service. Requires login
// (the DSAR resolvers are per-user on besthand-api). Mirrors the deleteAccount
// route guard pattern.
function action({ store }) {
  const title = store.getState().siteSettings?.data?.siteTitle;
  const description = store.getState().siteSettings?.data?.metaDescription;
  const isAuthenticated = store.getState().runtime.isAuthenticated;

  if (!isAuthenticated) {
    // COMPLIANCE: render a public CCPA explainer for logged-out visitors/crawlers instead of a bare
    // redirect (mirrors the /delete-account fix — declared URLs must resolve to real content).
    return {
      title: `Your privacy & data rights — ${title || 'BestHand'}`,
      description,
      component: (
        <Layout>
          <DeleteAccountPublic mode="data-rights" />
        </Layout>
      ),
    };
  }

  return {
    title: `Your privacy & data rights — ${title || 'BestHand'}`,
    description,
    component: (
      <Layout>
        <div className={'subPageMainContainer'}>
          <SubNavBar />
          <DataRights />
        </div>
      </Layout>
    ),
  };
}

export default action;
